const data = {
  title: "Floor 4-6",
  musicTrack: "MUSIC_WORLD4",
  theme: "GRAY",
  tilesWidth: 12,
  tilesHeight: 7,
  placements: [
    {
      type: "HERO_SPAWN",
      x: 2,
      y: 2
    },
    {
      type: "PLACEMENT_TYPE_GOAL",
      x: 2,
      y: 6
    },
    {
      type: "WALL",
      x: 6,
      y: 1
    },
    {
      type: "WALL",
      x: 8,
      y: 1
    },
    {
      type: "WALL",
      x: 10,
      y: 1
    },
    {
      type: "WALL",
      x: 8,
      y: 6
    },
    {
      type: "WALL",
      x: 6,
      y: 6
    },
    {
      type: "WALL",
      x: 10,
      y: 6
    },
    {
      type: "WALL",
      x: 5,
      y: 1
    },
    {
      type: "WALL",
      x: 7,
      y: 1
    },
    {
      type: "WALL",
      x: 9,
      y: 1
    },
    {
      type: "WALL",
      x: 11,
      y: 1
    },
    {
      type: "WALL",
      x: 4,
      y: 1
    },
    {
      type: "WALL",
      x: 4,
      y: 5
    },
    {
      type: "WALL",
      x: 4,
      y: 6
    },
    {
      type: "WALL",
      x: 4,
      y: 2
    },
    {
      type: "WALL",
      x: 4,
      y: 3
    },
    {
      type: "WALL",
      x: 12,
      y: 1
    },
    {
      type: "WALL",
      x: 12,
      y: 6
    },
    {
      type: "WALL",
      x: 12,
      y: 5
    },
    {
      type: "WALL",
      x: 12,
      y: 4
    },
    {
      type: "WALL",
      x: 12,
      y: 3
    },
    {
      type: "WALL",
      x: 12,
      y: 2
    },
    {
      type: "WALL",
      x: 10,
      y: 2
    },
    {
      type: "WALL",
      x: 8,
      y: 2
    },
    {
      type: "WALL",
      x: 6,
      y: 2
    },
    {
      type: "WALL",
      x: 4,
      y: 7
    },
    {
      type: "WALL",
      x: 6,
      y: 7
    },
    {
      type: "WALL",
      x: 8,
      y: 7
    },
    {
      type: "WALL",
      x: 10,
      y: 7
    },
    {
      type: "WALL",
      x: 12,
      y: 7
    },
    {
      type: "WALL",
      x: 6,
      y: 3
    },
    {
      type: "WALL",
      x: 8,
      y: 3
    },
    {
      type: "WALL",
      x: 10,
      y: 3
    },
    {
      type: "WALL",
      x: 6,
      y: 5
    },
    {
      type: "WALL",
      x: 8,
      y: 5
    },
    {
      type: "WALL",
      x: 10,
      y: 5
    },
    {
      type: "WALL",
      x: 9,
      y: 7
    },
    {
      type: "WALL",
      x: 11,
      y: 7
    },
    {
      type: "WALL",
      x: 7,
      y: 7
    },
    {
      type: "WALL",
      x: 5,
      y: 7
    },
    {
      type: "TELEPORT",
      x: 5,
      y: 2
    },
    {
      type: "TELEPORT",
      x: 7,
      y: 2
    },
    {
      type: "TELEPORT",
      x: 9,
      y: 2
    },
    {
      type: "TELEPORT",
      x: 11,
      y: 2
    },
    {
      type: "TELEPORT",
      x: 5,
      y: 6
    },
    {
      type: "TELEPORT",
      x: 7,
      y: 6
    },
    {
      type: "TELEPORT",
      x: 9,
      y: 6
    },
    {
      type: "TELEPORT",
      x: 11,
      y: 6
    },
    {
      type: "CHIP",
      x: 11,
      y: 5
    },
    {
      type: "CHIP",
      x: 9,
      y: 5
    },
    {
      type: "CHIP",
      x: 7,
      y: 5
    },
    {
      type: "CHIP",
      x: 5,
      y: 5
    },
    {
      type: "CHIP",
      x: 5,
      y: 3
    },
    {
      type: "CHIP",
      x: 7,
      y: 3
    },
    {
      type: "CHIP",
      x: 9,
      y: 3
    },
    {
      type: "CHIP",
      x: 11,
      y: 3
    },
    {
      type: "ENEMY_SPAWN",
      x: 10,
      y: 4,
      enemyType: "ROAMING_ENEMY"
    },
    {
      type: "ENEMY_SPAWN",
      x: 8,
      y: 4,
      enemyType: "ROAMING_ENEMY"
    },
    {
      type: "ENEMY_SPAWN",
      x: 6,
      y: 4,
      enemyType: "ROAMING_ENEMY"
    },
    {
      type: "CLOWN_DEFENSE_PICKUP",
      x: 4,
      y: 4
    }
  ]
};

export default data;
